import "/src/components/cookie-banner/index"
import {TRACKING_SERVICE_KEY, trackingService} from "./services/tracking/tracking-service";

if (!window[TRACKING_SERVICE_KEY]) {
    window[TRACKING_SERVICE_KEY] = trackingService;
}